export const Divider = {
    MuiDivider: {
        variants: [
            {
                props: {
                    variant: "dashed"
                },
                style: ()=>({
                        borderStyle: "dashed",
                        backgroundColor: "transparent"
                    })
            }
        ]
    }
};

//# sourceMappingURL=Divider.js.map